const mTableAdvancedServer = {
  unitError: 'Por favor, selecione o local',
  removed: 'Removedo com sucesso',
};

export default mTableAdvancedServer;
